import { FC } from "react";

import DeleteModal from "@/components/molecules/modals/DeleteModal";

interface Props {
  serviceName: string;
  isOpen: boolean;
  close: () => void;
  submit: () => void;
}

export const ServiceDeleteModal: FC<Props> = ({
  serviceName,
  isOpen,
  close,
  submit,
}) => {
  return (
    <DeleteModal
      isOpen={isOpen}
      handleClose={close}
      handleSubmit={submit}
      title="サービス削除"
      btnText="削除"
    >
      <p>[{serviceName}] を削除しますか？</p>
    </DeleteModal>
  );
};
